<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
			<v-flex lg12 class="userInfo">
				<div class="historyBox" v-for="history in objQuoteHistory">
					<table width="100%">
						<tr>
							<td ><strong>NEW STATUS:</strong></td>
							<td>{{ history.new_value }}</td>
						</tr>
						<tr>
							<td ><strong>PREVIOUS STATUS:</strong></td></td>
							<td>{{ history.prev_value }}</td>
						</tr>
						<tr>
							<td><strong>DATE CHANGED:</strong></td>
							<td>{{ history.timestamp }}</td>
						</tr>
						<tr>
							<td><strong>CHANGED BY:</strong></td>
							<td>{{ history.name }} {{ history.surname }}</td>
						</tr>
						<tr>
							<td><strong>COMMENTS:</strong></td>
              <td v-if="history.showEdit == true">
                <v-select class="dropdown dashDroprep" v-if="history.is_customer_reject == 1" v-model="history.data" :items="rejectReasons" item-value="id" item-text="name" autocomplete solo single-line></v-select>
                <!--
                <select name="msg" id="msg" style="padding: 14px;width:100%;margin-bottom: 20px;">
                    <option value="Not Interested Anymore">Not Interested Anymore</option>
                    <option value="Cost">Cost</option>
                    <option value="Unhappy With The Service">Unhappy With The Service</option>
                    <option value="Was Just Cost Checking">Was Just Cost Checking</option>
                </select>
                -->
                <v-text-field v-if="history.is_customer_reject == 0" style="margin-top: 10px;" label="Update Comment" v-model="history.data" multiLine solo></v-text-field>
                <v-btn class="text-xs-right success" style="margin-left: 1px;" @click.stop="fncEditReason(history)">Update</v-btn>
                <v-btn class="text-xs-right cancelButton" style="margin-left: 1px;" @click.stop="fncEditReason(history)">Cancel</v-btn>
              </td>
							<td v-else>{{ fncCheckComment(history.data) }}</td>
						</tr>
            <tr v-if="history.showEdit == false && fncCanEditComment(history) == true">
              <td width="30%"></td>
              <td><v-btn class="text-xs-right success" style="margin-left: 1px !important;" @click.stop="fncShowReasonEdit(history)">Edit Comment</v-btn></td>
            </tr>
					</table>
				</div>
				<p v-if="Object.keys(objQuoteHistory).length === 0">There are no status changes recorded for this entry.</p>
			</v-flex>
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				objUser: 0,
        rejectReasons: [
          { id: 'Not Interested Anymore', name: 'Not Interested Anymore' },
          { id: 'Cost', name: 'Cost' },
          { id: 'Unhappy With The Service', name: 'Unhappy With The Service' },
          { id: 'Was Just Cost Checking', name: 'Was Just Cost Checking' }
        ],
			};
		},
		methods: {
      fncCanEditComment( history ) {
        if( history.is_customer_reject == 1 && ( history.data == null || history.data == '' || history.data == 'null' ) ) {
          return true;
        } else if( history.user == this.objAuthorize.id ) {
          return true;
        }
        return false;
      },
      fncEditReason( history ) {
        this.$store.dispatch('fncUpdateStatusReason', history)
        for( var h in this.objQuoteHistory ) {
          if( this.objQuoteHistory[h].id == history.id ) {
            this.objQuoteHistory[h].showEdit = false;
          }
        }
      },
      fncShowReasonEdit( history ) {
        for( var h in this.objQuoteHistory ) {
          if( this.objQuoteHistory[h].id == history.id ) {
            this.objQuoteHistory[h].showEdit = true;
          }
        }
      },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
      fncCheckComment(comment) {
          if( comment == '' || comment == null || comment == 'null' ) {
              return 'No Comment';
          } else {
              return comment;
          }
      }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'objQuoteHistory'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
